export const isEventTargetNode = (eventTarget: EventTarget | null): eventTarget is Node => (
  !!eventTarget && 'nodeType' in eventTarget
);
